import { render, staticRenderFns } from "./CustomerAndOrderTypeSelection.vue?vue&type=template&id=1278fb47&scoped=true&"
import script from "./CustomerAndOrderTypeSelection.vue?vue&type=script&lang=js&"
export * from "./CustomerAndOrderTypeSelection.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAndOrderTypeSelection.vue?vue&type=style&index=0&id=1278fb47&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1278fb47",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VIcon})
